import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { BlissLoader } from './BlissLoader';

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <BlissLoader />
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};
